import { useStore } from "@stores";
import { useEffect } from "react";

export const usePromotions = (tenantId: string | number | undefined) => {
  const { promotionStore } = useStore();
  const { promotions, loading } = promotionStore;

  useEffect(() => {
    tenantId && promotionStore.getAll(Number(tenantId));

    return () => promotionStore.reset();
  }, [promotionStore, tenantId]);

  return { promotions, loading };
};
